import * as actionTypes from "./actionTypes";

export default function storeReducer(state = [], action) {
  switch (action.type) {
    case actionTypes.ADD_STORE_SUCCESS:
      return [...action.stores];
    case actionTypes.GET_STORES_SUCCESS:
      return [...action.stores];
    case actionTypes.EDIT_STORE_SUCCESS:
      return [...action.stores];
    case actionTypes.DELETE_STORE_SUCCESS:
      return state.filter((s) => s.storeid !== action.store.storeId);
    default:
      return state;
  }
}
